import {
  FormPageInputItem,
  FormPageInputItemMailAddress,
  FormPageInputItemMailAddressAtSignSeparated,
  FormPageInputItemMailAddressDomainPulldown,
  FormPageInputItemMailAddressFree,
  INPUT_ITEM_TYPE,
  MailAddressProperty,
  MailAddressPropertyDomainPulldown,
  MAIL_ADDRESS_PROPERTY_INPUT_TYPE,
} from 'shared';

const handleFree = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMailAddressFree => {
  const inputItemType = INPUT_ITEM_TYPE.mailAddressFree;
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.mailAddressFree) {
    return {
      inputItemType,
      mailAddress: formPageInputItem.mailAddress || '',
    };
  }
  return {
    inputItemType,
    mailAddress: '',
  };
};

const handleAtSignSeparated = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMailAddressAtSignSeparated => {
  const inputItemType = INPUT_ITEM_TYPE.mailAddressAtSignSeparated;
  if (
    formPageInputItem?.inputItemType ===
    INPUT_ITEM_TYPE.mailAddressAtSignSeparated
  ) {
    return {
      inputItemType,
      local: formPageInputItem.local || '',
      domain: formPageInputItem.domain || '',
    };
  }
  return {
    inputItemType,
    local: '',
    domain: '',
  };
};

const handleDomainPulldownDomain = (
  domain: MailAddressPropertyDomainPulldown['inputFormat']['domain'],
  inputItemDomain?: string
): string => {
  if (!inputItemDomain) {
    return domain[0] || '';
  }
  const includeInputItemDomain = domain.includes(inputItemDomain);
  if (includeInputItemDomain) {
    return inputItemDomain;
  }
  return domain[0] || '';
};
const handleDomainPulldown = (
  domain: MailAddressPropertyDomainPulldown['inputFormat']['domain'],
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMailAddressDomainPulldown => {
  const inputItemType = INPUT_ITEM_TYPE.mailAddressDomainPulldown;
  if (
    formPageInputItem?.inputItemType ===
    INPUT_ITEM_TYPE.mailAddressDomainPulldown
  ) {
    return {
      inputItemType,
      local: formPageInputItem.local || '',
      domain: handleDomainPulldownDomain(domain, formPageInputItem.domain),
    };
  }
  return {
    inputItemType,
    local: '',
    domain: domain[0] || '',
  };
};

export const convertMailAddressInitialValue = (
  property: MailAddressProperty,
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMailAddress => {
  const { free, atSignSeparated, domainPulldown } =
    MAIL_ADDRESS_PROPERTY_INPUT_TYPE;
  switch (property.inputFormat.inputType) {
    case free: {
      return handleFree(formPageInputItem);
    }
    case atSignSeparated:
      return handleAtSignSeparated(formPageInputItem);
    case domainPulldown:
      return handleDomainPulldown(
        property.inputFormat.domain,
        formPageInputItem
      );
  }
};
